
import { CSS } from '../../styles/stitches.config';
import {VariantType} from "./types";

const Subtitle20BoldStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: '30px',
    color: '#04192E',
};

const Subtitle18RegularStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '18px',
    lineHeight: '28px',
    color: '#04192E',
};

const Subtitle18MediumStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#04192E',
};
const Subtitle18SemiBoldStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#04192E',
};
const Body14SemiBoldStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    color: '#04192E',
};
const Body14RegularStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
    color: '#04192E',
};
const Body20RegularStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#04192E',
};

const Subtitle20MediumStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '30px',
    color: '#04192E',
};

const Body16SemiBoldStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#04192E',
};
const Body16MediumStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#676767',
};

const Body14MediumStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '22px',
    color: '#676767',
};

const TitleH324BoldStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '24px',
    lineHeight: '32px',
    color: '#04192E',
};
const TitleH264BoldStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '64px',
    lineHeight: '78px',
    color: '#7F53FF',
};

const TitleH172BoldStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '72px',
    lineHeight: '87px',
    color: '#7F53FF',
};

const TitleH232BoldStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '32px',
    lineHeight: '40px',
    color: '#04192E',
};

const TitleH142BoldStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '42px',
    lineHeight: '58px',
    color: '#04192E',
};

const Caption12SemiBoldStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '18px',
    color: '#04192E',
};

const Caption12RegularStyle: CSS = {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '18px',
    color: '#04192E',
};

export const getTypographyStyle = (variant: VariantType): CSS => {
    switch (variant) {
        case 'body-16-semi-bold':
            return Body16SemiBoldStyle;
        case 'body-16-medium':
            return Body16MediumStyle;
        case 'subtitle-20-bold':
            return Subtitle20BoldStyle;
        case 'subtitle-18-medium':
            return Subtitle18MediumStyle;
        case 'subtitle-18-regular':
            return Subtitle18RegularStyle;
        case 'subtitle-18-semibold':
            return Subtitle18SemiBoldStyle;
        case 'subtitle-20-medium':
            return Subtitle20MediumStyle;
        case 'body-16-regular':
            return Body20RegularStyle;
        case 'body-14-medium':
            return Body14MediumStyle;
        case 'body-14-semi-bold':
            return Body14SemiBoldStyle;
        case 'body-14-regular':
            return Body14RegularStyle;
        case 'title-h3-24-bold':
            return TitleH324BoldStyle;
        case 'caption-12-semi-bold':
            return Caption12SemiBoldStyle;
        case 'caption-12-regular':
            return Caption12RegularStyle;
        case 'title-h1-42-bold':
            return TitleH142BoldStyle;
        case 'title-h2-32-bold':
            return TitleH232BoldStyle;
        case 'title-h2-64-medium':
            return TitleH264BoldStyle;
        case 'title-h1-72-bold':
            return TitleH172BoldStyle;
        default:
            throw new Error('invalid argument');
    }
};
